// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ResetPassword_resetPasswordContainer__Nj7L8 {
  max-width: 400px;
  margin: 0 auto;
  padding: 20px;
  font-family: Arial, sans-serif;
  line-height: 1.6;
  text-align: center;
  border: 1px solid #ddd;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.ResetPassword_title__atKSs {
  font-size: 1.8rem;
  margin-bottom: 10px;
  color: #333;
}

.ResetPassword_subtitle__ICHry {
  font-size: 1rem;
  color: #555;
  margin-bottom: 20px;
}

.ResetPassword_form__on25n {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.ResetPassword_inputGroup__N9jHm {
  text-align: left;
}

.ResetPassword_label__avSNi {
  display: block;
  font-size: 0.9rem;
  margin-bottom: 5px;
  color: #444;
}

.ResetPassword_input__9xV8K {
  width: 100%;
  padding: 8px 12px;
  font-size: 1rem;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
}

.ResetPassword_input__9xV8K:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 4px rgba(0, 123, 255, 0.25);
}

.ResetPassword_submitButton__wjYJb {
  padding: 10px 15px;
  font-size: 1rem;
  color: #fff;
  background-color: #007bff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.ResetPassword_submitButton__wjYJb:disabled {
  background-color: #b3d7ff;
  cursor: not-allowed;
}

.ResetPassword_message__K-2o0 {
  margin-top: 20px;
  font-size: 1rem;
  color: #28a745;
}`, "",{"version":3,"sources":["webpack://./src/Component/ResetPassword.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB","sourcesContent":[".resetPasswordContainer {\n  max-width: 400px;\n  margin: 0 auto;\n  padding: 20px;\n  font-family: Arial, sans-serif;\n  line-height: 1.6;\n  text-align: center;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.title {\n  font-size: 1.8rem;\n  margin-bottom: 10px;\n  color: #333;\n}\n\n.subtitle {\n  font-size: 1rem;\n  color: #555;\n  margin-bottom: 20px;\n}\n\n.form {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n}\n\n.inputGroup {\n  text-align: left;\n}\n\n.label {\n  display: block;\n  font-size: 0.9rem;\n  margin-bottom: 5px;\n  color: #444;\n}\n\n.input {\n  width: 100%;\n  padding: 8px 12px;\n  font-size: 1rem;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  box-sizing: border-box;\n}\n\n.input:focus {\n  outline: none;\n  border-color: #007bff;\n  box-shadow: 0 0 4px rgba(0, 123, 255, 0.25);\n}\n\n.submitButton {\n  padding: 10px 15px;\n  font-size: 1rem;\n  color: #fff;\n  background-color: #007bff;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.submitButton:disabled {\n  background-color: #b3d7ff;\n  cursor: not-allowed;\n}\n\n.message {\n  margin-top: 20px;\n  font-size: 1rem;\n  color: #28a745;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"resetPasswordContainer": `ResetPassword_resetPasswordContainer__Nj7L8`,
	"title": `ResetPassword_title__atKSs`,
	"subtitle": `ResetPassword_subtitle__ICHry`,
	"form": `ResetPassword_form__on25n`,
	"inputGroup": `ResetPassword_inputGroup__N9jHm`,
	"label": `ResetPassword_label__avSNi`,
	"input": `ResetPassword_input__9xV8K`,
	"submitButton": `ResetPassword_submitButton__wjYJb`,
	"message": `ResetPassword_message__K-2o0`
};
export default ___CSS_LOADER_EXPORT___;
